
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/s/[id]",
      function () {
        return require("private-next-pages/s/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/s/[id]"])
      });
    }
  